export default __webpack_public_path__ + "static/media/p10.e4f3d569.jpg";